var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  fancy: "",
                                  required: "",
                                  label: "Code",
                                },
                                model: {
                                  value: _vm.code.code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.code, "code", $$v)
                                  },
                                  expression: "code.code",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("w-input-number", {
                                attrs: {
                                  fancy: "",
                                  min: 0.0,
                                  max: 100.0,
                                  label: "Percentage",
                                },
                                model: {
                                  value: _vm.code.percentage,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.code, "percentage", $$v)
                                  },
                                  expression: "code.percentage",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("w-date-picker", {
                                attrs: { fancy: "", label: "Van" },
                                model: {
                                  value: _vm.code.from,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.code, "from", $$v)
                                  },
                                  expression: "code.from",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("w-date-picker", {
                                attrs: { fancy: "", label: "Tot" },
                                model: {
                                  value: _vm.code.till,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.code, "till", $$v)
                                  },
                                  expression: "code.till",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("w-input-number", {
                                attrs: {
                                  fancy: "",
                                  label: "Max aantal keren gebruikt",
                                  disabled: _vm.code.uses == -1,
                                },
                                model: {
                                  value: _vm.code.uses,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.code, "uses", $$v)
                                  },
                                  expression: "code.uses",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("w-checkbox", {
                                attrs: {
                                  value: _vm.code.uses == -1,
                                  label: "Onbeperkt",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.setInfiniteUses($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: !_vm.isValid },
                          on: {
                            click: function ($event) {
                              return _vm.submit()
                            },
                          },
                        },
                        [
                          _c("w-fa", { attrs: { icon: "save" } }),
                          _vm._v(" Opslaan"),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }